import {
  ViewLatestArticles,
  ViewLatestVacancies,
  ViewLatestStories,
  ViewLatestProjects,
  ViewLatestPointsOfView,
  ViewLatestLocationContent,
  ViewRecentEntities,
  ViewRecentEntitiesLarge,
  ViewVacanciesByIds,
  ViewLatestThemes,
} from '../implementations';

const mappers = {
  views_block__latest_articles_block_1: ViewLatestArticles,
  views_block__latest_articles_block_2: ViewLatestArticles,
  views_block__latest_articles_block_3: ViewLatestArticles,
  views_block__latest_vacancies_block_1: ViewLatestVacancies,
  views_block__latest_stories_block_1: ViewLatestStories,
  views_block__latest_projects_block_1: ViewLatestProjects,
  views_block__latest_points_of_view_block_1: ViewLatestPointsOfView,
  views_block__latest_location_content_block_1: ViewLatestLocationContent,
  views_block__latest_location_content_block_2: ViewLatestLocationContent,
  views_block__latest_location_content_block_3: ViewLatestLocationContent,
  views_block__latest_location_content_block_4: ViewLatestLocationContent,
  views_block__latest_location_content_block_5_two_projects: ViewLatestLocationContent,
  views_block__latest_location_content_block_6_two_articles: ViewLatestLocationContent,
  views_block__recent_articles_block_1: ViewRecentEntities,
  views_block__recent_articles_block_2: ViewRecentEntitiesLarge,
  views_block__recent_articles_block_3: ViewRecentEntities,
  views_block__recent_articles_block_4: ViewRecentEntitiesLarge,
  views_block__recent_articles_block_5: ViewRecentEntities,
  views_block__recent_articles_block_6: ViewRecentEntitiesLarge,
  views_block__recent_articles_block_7: ViewRecentEntities,
  views_block__recent_articles_block_8: ViewRecentEntitiesLarge,
  views_block__latest_vacancies_block_2: ViewVacanciesByIds,
  views_block__latest_themes_latest: ViewLatestThemes,

};

export default mappers;
